<template>
    <button
        class="
            flex
            gap-1
            py-1
            px-2
            ml-auto
            bg-primary
            font-bold
            rounded-lg
            text-white
            items-center
            text-sm
        "
        @click="sync()"
    >
        <ion-icon name="sync-outline"></ion-icon>
        Sync
    </button>
    <MiniModalCustom :is-open="state.isProcessing">
        <div class="flex flex-col items-center justify-center pt-4">
            <LoadingCircle></LoadingCircle>
            <div class="mt-3 text-[16px] text-bold">
                Importing "{{ team["name"] }}" Data...
            </div>
        </div>
    </MiniModalCustom>
</template>

<script setup>
import { defineProps, reactive } from "vue";

const props = defineProps({
    team: Object,
});

const state = reactive({
    isProcessing: false,
});

async function sync() {
    state.isProcessing = true;
    try {
        await axios.post("/teamsnap/sync", props.team["cn_team"]);
    } catch (e) {
        console.log(e);
    }
    state.isProcessing = false;
    window.location.reload();
}
</script>
